import { Grid, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React, { useState } from 'react';
import Card from '../../../../../components/Card';
import OccurrencesPeriodStatusList from './OccurrencesPeriodStatusList';
import OccurrencesTodayStatusList from './OccurrencesTodayStatusList';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      height: '100%',
    },
    tabItem: {
      padding: theme.spacing(2),
      cursor: 'pointer',
    },
    tabItemInactive: {
      backgroundColor: theme.palette.grey[300],
    },
  }),
);

const OccurrencesStatusTabCard: React.FC = () => {
  const classes = useStyles();
  const [activedTab, setActiveTab] = useState(0);

  return (
    <Card className={classes.card}>
      <Grid container>
        <Grid
          onClick={() => {
            setActiveTab(0);
          }}
          className={`${classes.tabItem} ${
            activedTab !== 0 && classes.tabItemInactive
          }`}
          item
          xs={6}
        >
          <Typography align="center" color="textSecondary" variant="h5">
            Hoje
          </Typography>
        </Grid>
        <Grid
          className={`${classes.tabItem} ${
            activedTab !== 1 && classes.tabItemInactive
          }`}
          onClick={() => setActiveTab(1)}
          item
          xs={6}
        >
          <Typography align="center" color="textSecondary" variant="h5">
            No Mês
          </Typography>
        </Grid>
      </Grid>

      <div style={{ overflowY: 'auto', height: 'calc(100% - 66px)' }}>
        <div style={{ display: activedTab !== 0 ? 'none' : 'block' }}>
          <OccurrencesTodayStatusList />
        </div>

        <div style={{ display: activedTab !== 1 ? 'none' : 'block' }}>
          <OccurrencesPeriodStatusList />
        </div>
      </div>
    </Card>
  );
};

export default OccurrencesStatusTabCard;
